import { ChartOptionConstants } from 'app/constants/constants';

export const COMPONENT_CONSTANTS = {
  DOCS_ID: 'docs',
  SENTIMENT_ID: 'sentimentScore',
  SETTINGS_COLUMNS: ['label', 'min', 'max', 'scoring', 'box-size'],
  JOURNEY_COLUMNS: ['label', 'scoring', 'show-on-timeline'],
  SENTIMENT_SETTINGS_COLUMNS: ['label', 'min', 'max', 'scoring', 'percentage-sentiment'],
  COLOR_COLUMN: 'color',
  DECIMALS_COLUMN: 'decimals',
  ACTION_COLUMN: 'action',
  TOP_BOTTOM_SCORING_MIN: 0,
  TOP_BOTTOM_SCORING_MAX: 1000,
  NPS_SCORING_MIN_PATTERN: '^[01]$',
  NPS_SCORING_MAX: 100,
  TOP_BOTTOM_SCORING_MIN_DEFAULT: 1,
  TOP_BOTTOM_SCORING_MAX_DEFAULT: 100,
  NPS_SCORING_MIN_DEFAULT: 1,
  NPS_SCORING_MAX_DEFAULT: 10,
};

export function getDefaultDecimalPrecision(fieldId?: string): string {
  if (isDocsField(fieldId)) {
    return '0';
  }

  return ChartOptionConstants.DEFAULT_DECIMAL_PRECISION.toString();
}

export function isDocsField(fieldId: string): boolean {
  return fieldId === COMPONENT_CONSTANTS.DOCS_ID;
}

export function isSentimentField(fieldId: string): boolean {
  return fieldId === COMPONENT_CONSTANTS.SENTIMENT_ID;
}
